<template>
  <div class="focus-card" :style="cardStyle">
    <div class="focus-card__top">
      <div class="focus-card__img">
        <img :src="image" :alt="title" />
      </div>
      <div class="focus-card__info">
        <h4 class="focus-card__title">{{ title }}</h4>
        <span class="focus-card__subtitle">{{ subtitle }}</span>
        <p class="focus-card__desc focus-card__desc--pc">{{ description }}</p>
      </div>
    </div>
    <p class="focus-card__desc focus-card__desc--mobile">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: "FocusCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    cardStyle() {
      const isOdd = this.index % 2 !== 0;
      return {
        backgroundColor: isOdd ? "#F3EEE5" : "#fbf8f3",
        border: "1px solid #DDD4C4",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.focus-card {
  border-radius: 16px;
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-sizing: border-box;

  &__top {
    display: flex;
    gap: 12px;
  }

  &__img {
    width: 172px;
    height: 172px;
    border-radius: 12px;
    overflow: hidden;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  &__info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  &__title {
    font-family: $font-family;
    font-size: 30px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0;
    text-align: left;
    line-height: 1.18;
  }

  &__subtitle {
    font-family: $font-family;
    font-size: 16px;
    font-weight: 700;
    color: #6a6256;
    text-align: left;
    display: block;
  }

  &__desc {
    font-family: $font-family;
    font-size: 14px;
    font-weight: normal;
    color: #6a6256;
    line-height: 1.72;
    margin: 0;
    text-align: left;

    &--mobile {
      display: none;
    }
  }

  @include mobile {
    &__img {
      width: 120px;
      height: 120px;
    }

    &__title {
      font-size: 22px;
    }

    &__subtitle {
      font-size: 14px;
    }

    &__desc {
      font-size: 13px;

      &--pc {
        display: none;
      }

      &--mobile {
        display: block;
      }
    }
  }
}
</style>
